import { Categories, EmojiStyle, SuggestionMode } from 'emoji-picker-react';
import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { IconArrowDownWide, IconAttach, IconClose, IconSendMessage, IconSmileSticker } from '../../../base/icons/svg';
import { areSmileysDisabled } from '../../functions';
import { Collapse, Tooltip } from '@mui/material';
import _, { sortBy } from 'lodash';
import TextareaAutosize from 'react-textarea-autosize';
import Avatar from '../../../base/avatar/components/Avatar';
import Icon from '../../../base/icons/components/Icon';
import { getLocalUserId, getParticipantById } from '../../../base/participants';
import { getFileType } from '../../../base/react/functions';
import { sendCommand, sendDirectCommand } from '../../../mod-command/slice';
import { isLocalParticipantCanChat } from '../../../vtchat-moderation/functions';
import { isLocalParticipantCanUpload } from '../../../vtfileupload-moderation/functions';
import { addFileUpload, removeFileUpload, requestSlot, setPendingMessage, updateFileUpload } from '../../../vtfileupload-moderation/slice';
import { setPrivateMessageRecipient } from '../../actions.any';
import OutsideClickCheckHandler from './OutsideClickCheckHandler';
import './style.css';
import { NOTIFICATION_TIMEOUT_TYPE, showErrorNotification } from '../../../notifications';
const EmojiPicker = React.lazy(() => import('emoji-picker-react'));
/**
 * Implements a React Component for drafting and submitting a chat message.
 *
 * @augments Component
 */
class ChatInput extends Component {
    /**
     * Initializes a new {@code ChatInput} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            showSmileysPanel: false,
            recipient: this.props.t('chat.sendAll'),
            isHighChatInput: false
        };
        this._textArea = React.createRef();
        this.emojiPanelRef = React.createRef();
        this.emojiButtonRef = React.createRef();
        // Bind event handlers so they are only bound once for every instance.
        this._onDetectSubmit = this._onDetectSubmit.bind(this);
        this._onMessageChange = this._onMessageChange.bind(this);
        this._onSmileySelect = this._onSmileySelect.bind(this);
        this._onSubmitMessage = this._onSubmitMessage.bind(this);
        this._toggleSmileysPanel = this._toggleSmileysPanel.bind(this);
        this._checkCanSend = this._checkCanSend.bind(this);
        this._onToggleSmileysPanel = this._onToggleSmileysPanel.bind(this);
        this._onEscHandler = this._onEscHandler.bind(this);
        this._onToggleSmileysPanelKeyPress = this._onToggleSmileysPanelKeyPress.bind(this);
        this._onSubmitMessageKeyPress = this._onSubmitMessageKeyPress.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
        this.onDragEnter = this.onDragEnter.bind(this);
        this.handleClickOutsideEmojiPanel = this.handleClickOutsideEmojiPanel.bind(this);
        this.draggingTimeout;
        this.renderRecipientTitle = this.renderRecipientTitle.bind(this);
        this.handleChatInputResize = this.handleChatInputResize.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}.
     *
     * @inheritdoc
     */
    componentDidMount() {
        if (isMobileBrowser()) {
            // Ensure textarea is not focused when opening chat on mobile browser.
            this._textArea?.current && this._textArea.current.blur();
        }
        else {
            this._focus();
        }
        let newListRecipients = this.props.canChat ? [
            { id: 'sendAll', title: 'chat.sendAll', value: 'chat.sendAll' }
        ]
            : [];
        newListRecipients = [
            ...this.props.remoteParticipants?.map(p => { return { id: p.id, title: p.value, value: p.key || 'chat.sendAll', avatarURL: p.avatarURL }; }) || [],
            ...newListRecipients
        ];
        this.setState({ listRecipients: newListRecipients });
        document.addEventListener("dragover", this.handleDragOver);
        document.addEventListener("dragleave", this.handleDragLeave);
        document.addEventListener("dragend", this.handleDragLeave);
        document.addEventListener("drop", this.handleDrop);
        document.addEventListener("mousedown", this.handleClickOutsideEmojiPanel);
    }
    /**
     * Implements {@code Component#componentDidUpdate}.
     *
     * @inheritdoc
     */
    componentDidUpdate(prevProps) {
        if (prevProps._privateMessageRecipientId !== this.props._privateMessageRecipientId) {
            this._textArea?.current?.focus();
        }
        if (prevProps.remoteParticipants !== this.props.remoteParticipants || prevProps.canChat !== this.props.canChat) {
            let newListRecipients = this.props.canChat ? [
                { id: 'sendAll', title: 'chat.sendAll', value: 'chat.sendAll' }
            ]
                : [];
            newListRecipients = [
                ...this.props.remoteParticipants?.map(p => { return { id: p.id, title: p.value, value: p.key || 'chat.sendAll', avatarURL: p.avatarURL }; }) || [],
                ...newListRecipients
            ];
            this.setState({ listRecipients: newListRecipients });
        }
        if (JSON.stringify(this.props.privateMessageRecipient) != JSON.stringify(prevProps.privateMessageRecipient)) {
            if (!this.props.privateMessageRecipient || !this.props.privateMessageRecipient?.userId) {
                const onConferenceParticipant = this.props.remoteParticipants?.find(rm => (rm.key === this.props.privateMessageRecipient?.id));
                if (onConferenceParticipant) {
                    this.handleChooseRecipient({ id: onConferenceParticipant.id, title: onConferenceParticipant.value, value: onConferenceParticipant.key || 'chat.sendAll' });
                }
                else {
                    this.handleChooseRecipient({ title: this.props.t('chat.sendAll'), value: this.props.t('chat.sendAll'), id: 'sendAll' });
                }
            }
            else {
                this._focus();
            }
        }
        if ((prevProps.canUpload !== this.props.canUpload || prevProps.privateMessageRecipient !== this.props.privateMessageRecipient)
            && (!this.props.canUpload && !this.props.privateMessageRecipient)) {
            this.props.dispatch(setPendingMessage(null));
            this.setState({ pendingFiles: [] });
            // this.props.dispatch!(emptyFileUpload())
        }
        if (prevProps.files?.length !== this.props.files?.length || !this.isArrayEqual(prevProps.files || [], this.props.files || [])) {
            const readyFiles = this.props.files?.filter(f => f.status === "ready");
            readyFiles?.forEach(async (f) => {
                let controller = new AbortController();
                // signal to pass to fetch
                let signal = controller.signal;
                this.props.dispatch(updateFileUpload({ ...f, controller, status: 'uploading' }));
                const realFile = this.state.pendingFiles?.find(rf => rf.id === f.id);
                let body = new FormData();
                body.append('file', realFile);
                const { postUrl, headers } = f;
                if (postUrl) {
                    try {
                        let requestInit = {
                            method: "POST",
                            body,
                            signal
                        };
                        if (headers) {
                            requestInit = { ...requestInit, headers };
                        }
                        const resp = await fetch(postUrl, requestInit);
                        if (resp.status == 200) {
                            this.props.dispatch(updateFileUpload({ ...f, src: null, status: 'uploaded' }));
                        }
                        else {
                            this.props.dispatch(updateFileUpload({ ...f, status: 'error', errorType: "when-upload" }));
                        }
                    }
                    catch (error) {
                        this.props.dispatch(updateFileUpload({ ...f, status: 'error', errorType: "when-upload" }));
                    }
                }
            });
            const uploadedFiles = this.props.files?.filter(f => f.status === "uploaded");
            if (uploadedFiles) {
                const uploadedIds = uploadedFiles.map(f => f.id);
                if (uploadedIds.length && this.props.pendingMessage) {
                    this.props.dispatch(setPendingMessage({
                        ...this.props.pendingMessage, files: this.props.pendingMessage.files?.map(fpm => uploadedIds.includes(fpm.id) ? { ...fpm, done: true } : fpm)
                    }));
                }
            }
        }
        if (prevProps.pendingMessage && this.props.pendingMessage && prevProps.pendingMessage !== this.props.pendingMessage) {
            const done = this.props.pendingMessage.files?.every(f => f.done);
            if (done) {
                const msgFileIds = this.props.pendingMessage.files?.map(f => f.id);
                if ((msgFileIds && msgFileIds.length > 0) || !!this.props.pendingMessage.message) {
                    this.props.onSend(this.props.pendingMessage.message, this.props.pendingMessage.to, this.props.files?.filter(f => msgFileIds?.includes(f.id)).map(f => ({
                        tag: 'file',
                        name: f.name,
                        type: f.type,
                        size: f.size,
                        url: f.getUrl
                    })));
                    if (msgFileIds)
                        this.props.dispatch(removeFileUpload(msgFileIds));
                }
                this.props.dispatch(setPendingMessage(null));
            }
        }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement("div", { className: `chat-input-container${this._checkCanSend(this.state.message.trim()) ? ' populated' : ''}` },
            this.state.isShowOptionRecipient &&
                React.createElement(OutsideClickCheckHandler, { parent: this, tag: "optionChatInput" },
                    React.createElement("div", { className: 'recipient-option' },
                        React.createElement("div", { style: {
                                maxHeight: '40vh',
                                overflowY: 'auto'
                            } }, [
                            ...sortBy(this.state.listRecipients?.filter(rec => rec.id && rec.id !== "sendAll") || [], "title"),
                            ...this.state.listRecipients?.filter(rec => rec.id && rec.id === "sendAll") || []
                        ].map(recipient => (React.createElement(Tooltip, { onClick: () => {
                                this.handleChooseRecipient(recipient);
                                //  this.setState({ recipient: recipient.value, isShowOptionRecipient: false }) 
                            }, className: `item-recipient ${(this.props.privateMessageRecipient?.id === recipient.value
                                // || this.state.recipientUserId === recipient.id
                                || (!this.props.privateMessageRecipient?.id && recipient.id === "sendAll"))
                                ? 'selected'
                                : ''}`, placement: "right", title: `${this.renderRecipientTitle(recipient.value)}` },
                            React.createElement("div", null,
                                React.createElement("div", { style: { marginRight: "8px" } }, recipient.id !== "sendAll" ?
                                    React.createElement(Avatar, { displayName: this.renderRecipientTitle(recipient.title), size: 20, avatarUrl: recipient?.avatarURL }) :
                                    React.createElement("div", { style: { width: 20 } })),
                                React.createElement("div", { className: 'text-ellipsis' }, this.renderRecipientTitle(recipient.title))))))))),
            React.createElement(Collapse, { className: 'file-queue', orientation: "horizontal", in: Boolean(this.props.fileQueue?.length) },
                React.createElement("div", { className: 'file-queue-container' }, this.props.fileQueue?.map(f => {
                    return (React.createElement("div", { className: 'file-queue-tooltip' },
                        React.createElement(Tooltip, { placement: "top", title: f.name },
                            React.createElement("div", { className: 'file-queue-item', onClick: (_) => this.handleRemoveQueueFile(f.id, this.props.dispatch) }, this.renderQueuePreview(f))),
                        React.createElement(Icon, { className: 'file-queue-remove', size: 20, src: IconClose, onClick: () => this.handleRemoveQueueFile(f.id, this.props.dispatch) }),
                        React.createElement("div", { className: 'file-queue-back' })));
                }))),
            React.createElement("div", { className: 'separate-line' }),
            React.createElement("div", { className: 'recipient-container' },
                React.createElement("div", { style: { display: 'flex', width: "60%" } },
                    React.createElement("div", { style: {
                            display: "flex",
                            alignItems: "center",
                            "whiteSpace": "nowrap"
                        } },
                        this.props.t('chat.send'),
                        ":"),
                    React.createElement("div", { onClick: () => { this.setState({ isShowOptionRecipient: !this.state.isShowOptionRecipient }); }, className: 'recipient arrow-down-icon' },
                        React.createElement("div", { style: { display: 'flex' } },
                            this.props.privateMessageRecipient ? (React.createElement(Tooltip, { style: { display: 'flex', alignItems: "center", overflow: "hidden" }, placement: "top", title: `${this.props.privateMessageRecipient.name}#${this.props.privateMessageRecipient.id}` },
                                React.createElement("div", null,
                                    React.createElement("div", { style: { marginRight: "8px" } },
                                        React.createElement(Avatar, { participantId: this.props.privateMessageRecipient?.id, size: 20 })),
                                    React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, this.props.privateMessageRecipient.name)))) : this.props.canChat ? (React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis", "whiteSpace": "nowrap" } }, this.props.t('chat.sendAll'))) : (React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis", "whiteSpace": "nowrap" } }, this.props.t('chat.chooseToChat'))),
                            React.createElement(Icon, { color: "#CB003D", className: 'custome-icon', size: 10, src: IconArrowDownWide })))),
                React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                    (this.props.canUpload || this.props.privateMessageRecipient) && !this.props.pendingMessage && (React.createElement(Tooltip, { placement: "top", title: this.props.t('chat.upload') },
                        React.createElement("div", { className: 'chat-input-icon' },
                            React.createElement("input", { type: "file", id: "attachFiles", name: "attachFiles", style: { display: 'none' }, onChange: (e) => {
                                    this.handleAddQueue(e, this.props.dispatch);
                                }, 
                                // onClick={(e) => e.target.value = ''}
                                multiple: true, accept: "\n                                                image/jpeg,\n                                                image/png,\n                                                image/gif,\n                                                image/webp, \n                                                video/*, \n                                                audio/*, \n                                                application/msword,\n                                                application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n                                                application/vnd.ms-powerpoint,\n                                                application/vnd.openxmlformats-officedocument.presentationml.presentation,\n                                                application/vnd.ms-excel,\n                                                application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\n                                                application/pdf,\n                                                text/plain,\n                                                application/vnd.rar,\n                                                application/zip,\n                                                application/x-zip-compressed,\n                                                application/x-7z-compressed\n                                            " }),
                            React.createElement("label", { htmlFor: "attachFiles" },
                                React.createElement(IconAttach, { width: "18", height: "18", style: { fill: "#44494D" } }))))),
                    this.props._areSmileysDisabled ? null : (React.createElement(Tooltip, { placement: "top", title: this.props.t('chat.emoji') },
                        React.createElement("div", { className: 'emoji chat-input-icon' },
                            this.state.showSmileysPanel && (React.createElement("div", { ref: this.emojiPanelRef, className: 'emoji-panel' },
                                React.createElement(Suspense, { fallback: React.createElement("div", null, "Emojing...") },
                                    React.createElement(EmojiPicker, { width: 300, height: '60vh', emojiStyle: EmojiStyle.APPLE, skinTonesDisabled: true, searchDisabled: true, onEmojiClick: (e) => { this._onSmileySelect(e); }, autoFocusSearch: false, searchPlaceHolder: this.props.t('chat.search'), previewConfig: {
                                            showPreview: false
                                        }, suggestedEmojisMode: SuggestionMode.FREQUENT, categories: [
                                            { name: this.props.t('chat.emojiCategories.suggested'), category: Categories.SUGGESTED },
                                            { name: this.props.t('chat.emojiCategories.smileys_people'), category: Categories.SMILEYS_PEOPLE },
                                            { name: this.props.t('chat.emojiCategories.animals_nature'), category: Categories.ANIMALS_NATURE },
                                            { name: this.props.t('chat.emojiCategories.food_drink'), category: Categories.FOOD_DRINK },
                                            // { name: this.props.t('chat.emojiCategories.travel_places'), category: Categories.TRAVEL_PLACES },
                                            // { name: this.props.t('chat.emojiCategories.activities'), category: Categories.ACTIVITIES },
                                            // { name: this.props.t('chat.emojiCategories.objects'), category: Categories.OBJECTS },
                                            { name: this.props.t('chat.emojiCategories.symbols'), category: Categories.SYMBOLS },
                                            { name: this.props.t('chat.emojiCategories.flags'), category: Categories.FLAGS }
                                        ] })))),
                            React.createElement("div", { ref: this.emojiButtonRef, "aria-expanded": this.state.showSmileysPanel, "aria-haspopup": 'dialog', "aria-label": this.props.t('chat.smileysPanel'), className: 'smiley-button', onClick: this._onToggleSmileysPanel, onKeyDown: this._onEscHandler, onKeyPress: this._onToggleSmileysPanelKeyPress, role: 'button', tabIndex: 0 },
                                React.createElement(IconSmileSticker, { width: "18", height: "18", style: { fill: "#44494D" } }))))))),
            React.createElement("div", { id: 'chat-input' },
                React.createElement("div", { className: `usrmsg-form${this.state.isDragOver ? ' drag-over' : this.state.isDragging ? ' dragging' : ''}` },
                    React.createElement(TextareaAutosize, { className: `${this.state.isHighChatInput ? 'high' : 'normal'}`, autoComplete: 'off', autoFocus: true, id: 'usermsg', maxRows: 5, onChange: (e) => this._onMessageChange(e.target.value), onHeightChange: this.handleChatInputResize, onKeyDown: this._onDetectSubmit, placeholder: this.state.isDragging || this.state.isDragOver ? this.props.t('chat.dropfile') : this.props.t('chat.messagebox', { recipient: this.ellipsisText(this.props.privateMessageRecipient?.name, 20) || this.props.t('chat.send-all') }), ref: this._textArea, tabIndex: 0, value: this.state.message, onPaste: (e) => this.handlePaste(e, this.props.dispatch), onDrop: e => this.onFileDrop(e, this.props.dispatch), 
                        // onDragOver={this.onDragOver}
                        onDragLeave: this.onDragLeave, onDragEnter: this.onDragEnter })),
                React.createElement(Tooltip, { placement: "top", title: this.props.t('chat.sendButton') },
                    React.createElement("div", { className: 'send-button-container' },
                        React.createElement("div", { "aria-label": this.props.t('chat.sendButton'), className: 'send-button', onClick: this._onSubmitMessage, onKeyPress: this._onSubmitMessageKeyPress, role: 'button', tabIndex: this.state.message.trim() ? 0 : -1 },
                            React.createElement(IconSendMessage, { width: 24, height: 24 })))))));
    }
    /**
     * Place cursor focus on this component's text area.
     *
     * @private
     * @returns {void}
     */
    _focus() {
        this._textArea?.current && this._textArea.current.focus();
    }
    _checkCanSend(trimmed) {
        if (!this.props.canChat && this.state.recipient === this.props.t('chat.sendAll')) {
            return false;
        }
        if (trimmed) {
            return true;
        }
        if (this.props.canUpload && this.props.fileQueue?.length) {
            return true;
        }
        if (this.state.recipient !== this.props.t('chat.sendAll') && this.props.fileQueue?.length) {
            return true;
        }
        return false;
    }
    handleClickOutsideEmojiPanel(e) {
        if (this.emojiPanelRef && !this.emojiPanelRef.current?.contains(e.target) && !this.emojiButtonRef.current?.contains(e.target)) {
            this.setState({ showSmileysPanel: false });
        }
    }
    handleDragOver(e) {
        clearTimeout(this.draggingTimeout);
        if (e.dataTransfer?.items && Array.from(e.dataTransfer?.items).some(item => item.kind === "file") || (e.dataTransfer?.files?.length || 0) > 0) {
            e.preventDefault();
            this.draggingTimeout = setTimeout(() => {
                this.setState({ isDragging: true });
            }, 100);
        }
    }
    handleDragLeave() {
        clearTimeout(this.draggingTimeout);
        this.draggingTimeout = setTimeout(() => {
            this.setState({ isDragging: false });
        }, 100);
    }
    handleDrop() {
        clearTimeout(this.draggingTimeout);
        this.setState({ isDragging: false });
    }
    isArrayEqual(x, y) {
        return _(x).differenceWith(y, _.isEqual).isEmpty();
    }
    ;
    handleUploadFiles(files) {
        files.forEach(file => {
            const { id, name, type, size } = file;
            this.props.dispatch(requestSlot({ id, name, type, size }));
        });
    }
    /**
     * Submits the message to the chat window.
     *
     * @returns {void}
     */
    _onSubmitMessage() {
        this.checkAndSendCommand(this.state.message);
        const trimmed = this.state.message.trim();
        if (this._checkCanSend(trimmed)) {
            if (!this.props.fileQueue?.length) {
                this.props.onSend(trimmed);
                this.setState({ message: '' });
                // Keep the textarea in focus when sending messages via submit button.
                this._focus();
            }
            else {
                const sendTo = this.props._privateMessageRecipientId ? this.props._privateMessageRecipientId : 'chat.sendAll';
                this.props.dispatch(setPendingMessage({ message: trimmed, to: sendTo, files: this.props.fileQueue.map(f => ({ id: f.id })) }));
                this.setState({ message: '' });
                this.handleUploadFiles(this.props.fileQueue);
                this._focus();
            }
        }
    }
    /**
     * Detects if enter has been pressed. If so, submit the message in the chat
     * window.
     *
     * @param {string} event - Keyboard event.
     * @private
     * @returns {void}
     */
    _onDetectSubmit(event) {
        // Composition events used to add accents to characters
        // despite their absence from standard US keyboards,
        // to build up logograms of many Asian languages
        // from their base components or categories and so on.
        if (event.isComposing || event.keyCode === 229) {
            // keyCode 229 means that user pressed some button,
            // but input method is still processing that.
            // This is a standard behavior for some input methods
            // like entering japanese or сhinese hieroglyphs.
            return;
        }
        if (event.key === 'Enter'
            && event.shiftKey === false
            && event.ctrlKey === false) {
            event.preventDefault();
            event.stopPropagation();
            this._onSubmitMessage();
        }
    }
    /**
     * Updates the known message the user is drafting.
     *
     * @param {string} value - Keyboard event.
     * @private
     * @returns {void}
     */
    _onMessageChange(value) {
        this.setState({ message: value });
    }
    /**
     * Appends a selected smileys to the chat message draft.
     *
     * @param {string} smileyText - The value of the smiley to append to the
     * chat message.
     * @private
     * @returns {void}
     */
    _onSmileySelect(data) {
        if (data.emoji) {
            this.setState({
                message: `${this.state.message} ${data.emoji}`,
                // showSmileysPanel: false
            });
        }
        // else {
        //     this.setState({
        //         showSmileysPanel: false
        //     });
        // }
        this._focus();
    }
    /**
     * Callback invoked to hide or show the smileys selector.
     *
     * @private
     * @returns {void}
     */
    _toggleSmileysPanel() {
        if (this.state.showSmileysPanel) {
            this._focus();
        }
        this.setState({ showSmileysPanel: !this.state.showSmileysPanel });
    }
    handleChooseRecipient(recipient, isClose = true) {
        if (recipient.value === 'chat.sendAll') {
            this.setState({ recipient: recipient.value, recipientId: null, recipientUserId: null });
            if (isClose)
                this.setState({ isShowOptionRecipient: false });
            this.props.dispatch(setPrivateMessageRecipient(undefined));
        }
        else {
            this.setState({ recipient: recipient.title, recipientId: recipient.value, recipientUserId: recipient.id });
            if (isClose)
                this.setState({ isShowOptionRecipient: false });
            const participant = getParticipantById(this.props._gstate, recipient.value);
            this.props.dispatch(setPrivateMessageRecipient(participant));
        }
        this._focus();
    }
    async addFileToQueue(f, dispatch) {
        if ((this.props.canUpload || this.props.privateMessageRecipient) && !this.props.pendingMessage) {
            const file = f;
            const id = uuidv4();
            file.id = id;
            const { name, type, size } = file;
            if ((type.includes("image") || type.includes("video")) && size < 25000000) {
                var reader = new FileReader();
                file.src = await new Promise((resolve) => {
                    reader.onload = (event) => resolve(event.target?.result || null);
                    reader.readAsDataURL(f);
                });
            }
            this.setState((prevState) => ({
                pendingFiles: prevState.pendingFiles ? [...prevState.pendingFiles, file] : [file]
            }));
            dispatch(addFileUpload({ id, name, type, size, src: file.src, status: 'inQueue' }));
        }
    }
    handleAddQueue(e, dispatch) {
        if (e.target.files) {
            Array.from(e.target.files).forEach(file => {
                const isSvg = file.type === "image/svg+xml" || file.name.toLowerCase().endsWith('.svg');
                if (isSvg) {
                    dispatch(showErrorNotification({
                        titleKey: 'chat.toast.fileInvalid'
                    }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
                }
                else {
                    this.addFileToQueue(file, dispatch);
                }
            });
        }
        this._focus();
    }
    checkAndSendCommand(text) {
        if (text.startsWith('/cmd ')) {
            const commands = text.split(' ');
            if (commands.length < 4) {
                this.props.dispatch(sendCommand(commands[1], commands[2], commands[3] && commands[3] === "1" ? true : false));
            }
            else if (commands.length > 4) {
                this.props.dispatch(sendDirectCommand(commands[3], commands[1], commands[2], commands[4] && commands[4] === "1" ? true : false));
            }
        }
    }
    /**
     * KeyPress handler for accessibility.
     *
     * @param {Object} e - The key event to handle.
     *
     * @returns {void}
     */
    _onSubmitMessageKeyPress(e) {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            this._onSubmitMessage();
        }
    }
    onDragLeave() {
        // e.preventDefault();
        this.setState({ isDragOver: false });
    }
    onDragEnter(e) {
        if (e.dataTransfer.items && Array.from(e.dataTransfer.items).some(item => item.kind === "file") || e.dataTransfer.files?.length > 0) {
            e.preventDefault();
            this.setState({ isDragOver: true });
        }
    }
    handlePaste(e, dispatch) {
        var items = e.clipboardData.items;
        for (var index in items) {
            var item = items[index];
            if (item.kind === 'file') {
                e.preventDefault();
                var file = item.getAsFile();
                if (file) {
                    this.addFileToQueue(file, dispatch);
                }
            }
        }
        this._focus();
    }
    onFileDrop(e, dispatch) {
        this.setState({ isDragOver: false });
        try {
            if (e.dataTransfer.items) {
                Array.from(e.dataTransfer.items)
                    .map((item) => {
                    if (item.kind === "file") {
                        e.preventDefault();
                        var file = item.getAsFile();
                        if (file) {
                            this.addFileToQueue(file, dispatch);
                        }
                    }
                });
            }
            else if (e.dataTransfer.files?.length > 0) {
                for (const file of Array.from(e.dataTransfer.files)) {
                    e.preventDefault();
                    this.addFileToQueue(file, dispatch);
                }
            }
        }
        catch (error) {
            console.log("Drop files failed: ", error);
        }
        this._focus();
    }
    handleRemoveQueueFile(id, dispatch) {
        this.setState({ pendingFiles: this.state.pendingFiles?.filter(pf => pf.id !== id) });
        dispatch(removeFileUpload([id]));
    }
    handleEmptyQueueFile(dispatch) {
        const queueIds = this.state.pendingFiles?.map(pf => pf.id) || [];
        this.setState({ pendingFiles: [] });
        dispatch(removeFileUpload(queueIds));
    }
    renderQueuePreview(file) {
        if (file.src && file.type?.includes('image')) {
            return (React.createElement(React.Fragment, null,
                React.createElement("img", { className: 'file image', src: file.src })));
        }
        else {
            return (React.createElement(Icon, { className: 'attachIcon', size: 30, src: getFileType(file.name).icon }));
        }
    }
    renderRecipientTitle(title) {
        if (!title)
            return 'undefined';
        return title === 'chat.sendAll' ? this.props.t('chat.sendAll') : title;
    }
    /**
     * Callback invoked to hide or show the smileys selector.
     *
     * @private
     * @returns {void}
     */
    _onToggleSmileysPanel() {
        if (this.state.showSmileysPanel) {
            this._focus();
        }
        this.setState({ showSmileysPanel: !this.state.showSmileysPanel });
    }
    /**
     * KeyPress handler for accessibility.
     *
     * @param {Object} e - The key event to handle.
     *
     * @returns {void}
     */
    _onEscHandler(e) {
        // Escape handling does not work in onKeyPress
        if (this.state.showSmileysPanel && e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            this._onToggleSmileysPanel();
        }
    }
    /**
     * KeyPress handler for accessibility.
     *
     * @param {Object} e - The key event to handle.
     *
     * @returns {void}
     */
    _onToggleSmileysPanelKeyPress(e) {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            this._onToggleSmileysPanel();
        }
    }
    someOneClickedOutsideMe() {
        this.setState({ isShowOptionRecipient: false });
    }
    handleChatInputResize(e) {
        if (e > 100) {
            this.setState({ isHighChatInput: true });
        }
        else {
            this.setState({ isHighChatInput: false });
        }
        if (this.props.onResize) {
            this.props.onResize();
        }
    }
    ellipsisText(text, number) {
        if (!text)
            return '';
        if (text.length < number + 2)
            return text;
        return text.slice(0, number) + "...";
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @private
 * @returns {{
 *     _areSmileysDisabled: boolean
 * }}
 */
const mapStateToProps = (state) => {
    const { remote } = state['features/base/participants'];
    const { privateMessageRecipient } = state['features/chat'];
    const { conference } = state['features/base/conference'];
    const participants = conference?.getParticipants();
    const canChat = isLocalParticipantCanChat(state);
    const canUpload = isLocalParticipantCanUpload(state);
    const { files, pendingMessage } = state['features/vt-file-upload-moderation'];
    const fileQueue = files.filter(f => f.status === 'inQueue');
    const userId = getLocalUserId();
    const specialStats = ["jibri", "jigasi"];
    return {
        _areSmileysDisabled: areSmileysDisabled(state),
        _privateMessageRecipientId: privateMessageRecipient?.id,
        remoteParticipants: Object.entries(participants || {}).map((p) => {
            return { id: p[1]._identity?.user?.id, key: p[1]._id, value: p[1]._displayName, avatarURL: remote.get(p[1]._id)?.avatarURL, statsID: p[1]._statsID };
        }).filter(p => !specialStats.includes(p.statsID)).reverse(),
        privateMessageRecipient: privateMessageRecipient ?
            {
                ...getParticipantById(state, privateMessageRecipient.id),
                id: privateMessageRecipient.id,
                conference: undefined,
                userId: participants[privateMessageRecipient.id]?._identity?.user?.id
            }
            : null,
        _gstate: state,
        canChat,
        files,
        fileQueue,
        canUpload,
        pendingMessage
    };
};
export default translate(connect(mapStateToProps)(ChatInput));
